import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { ViewExpectFundComponent } from '../view-expect-fund/view-expect-fund.component';
import { ManageRolesComponent } from '../manage-roles/manage-roles.component';
import { UserRole } from '../shared/models/user-role';
import { ManageUserRoleService } from '../shared/services/manage-user-role.service';
import { Router } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { JurisdictionService } from '../shared/services/jurisdiction.service';
import { Jurisdiction } from '../shared/models/jurisdiction';
import { ManageSupportedJurisdictionComponent } from '../manage-supported-jurisdiction/manage-supported-jurisdiction.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
    isExpanded = false;
    userIntials: string | undefined;
    loggedIn: Boolean = false;
    isAccessToManageRoles: Boolean = false;
    userRolePermissions?: UserRole;
    hasAccessToPaymentRequest: boolean = false;
    hasAccessToExpectFund: boolean = false;
    hasAccessToApprovals: boolean = false;
    hasAccessToTransferFunds: boolean = false;
    hasAccessToJournalRequest: boolean = false;
    hasAccessToViewLogs: boolean = false;
    currentJurisdiction: string = '';
    constructor(
        public userService: UserService,
        private dialog: MatDialog,
        private manageUserRoleService: ManageUserRoleService,
        private router: Router,
        private commonService: CommonService,
        private jurisdictionService: JurisdictionService
    ) { }

    ngOnInit() {
        this.checkLogin();

        this.manageUserRoleService.getUserPermissionsByRole(this.userService.userDetails?.userRole!).then((res: UserRole) => {
            if (res) {
                this.isAccessToManageRoles = res.manageRoles;
                this.currentJurisdiction = res.jurisdiction?.jurisdictionName ?? "";
                sessionStorage.setItem("currentJurisdiction", this.currentJurisdiction ?? "");
                this.currentJurisdiction = sessionStorage.getItem("currentJurisdiction") ?? "";

                this.userRolePermissions = res;
                this.hasAccessToPaymentRequest = res.request;
                this.hasAccessToExpectFund = res.request;
                this.hasAccessToTransferFunds = res.request;
                this.hasAccessToJournalRequest = res.request;
                this.userService.setHasAccessToViewLogs(res.viewAuditLog);
                this.hasAccessToViewLogs = res.viewAuditLog;
                this.hasAccessToApprovals = res.partnerApprove || res.accountsApprove;
                if (res.request && window.location.href.includes("-request")) {
                    return;
                }
                else if ((res.accountsApprove || res.partnerApprove) && window.location.href.includes("-approval")) {
                    return;
                }
                else if (window.location.href.includes("audit")) {
                    return;
                }
                else if (window.location.href.includes("disbursement")) {
                    return;
                }
                else if ((res.request == false) && (res.partnerApprove == false) && (res.accountsApprove == false) && (res.viewAuditLog == false)) {
                    this.router.navigate(['/no-permissions']);
                }
                else if ((res.request == false && (res.partnerApprove == true || res.accountsApprove == true))) {
                    this.router.navigate(['/approvals']);
                }
                else if (res.request == false && res.partnerApprove == false && res.accountsApprove == false) {
                    this.router.navigate(['/audit']);
                }
                else if ((res.partnerApprove == true || res.accountsApprove == true)) {
                    this.router.navigate(['/approvals']);
                }
                else {
                    this.router.navigate(['/payment-request']);
                }
            } else {
                this.userService.userDetails = undefined;
                this.userService.isAutherized = false;
                localStorage.clear();
                this.router.navigate(['/']);
            }
        });
    }
    

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    checkLogin() {
        if (localStorage.getItem("token") && this.userService.userDetails?.fullName) {
            this.loggedIn = true;
        }
    }

    logOut(): void {
        this.openLogoutConfirmDialog().subscribe(confirm => {
            if (confirm) {
                this.commonService.logOut();
            }
        });
    }

    openLogoutConfirmDialog() {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            panelClass: 'confirm-dialog',
            width: '400px',
            disableClose: true,
            data: {
                title: 'Confirm Logout',
                message: 'Are you sure you want to logout? You will be redirected to the login page.',
                confirmText: 'Logout',
                buttonType:'cancelOnly'
            }
        });

        return dialogRef.afterClosed();
    }

    manageRoles() {
        this.openManageRoles();
    }

    async openManageRoles() {

        let data: UserRole[] = [];

        try {
            await this.manageUserRoleService.getAllRoleBasedAccess().then((res: UserRole[]) => {
                if (res.length > 0) {
                    data = res;
                }
            })

            const dialogRef = this.dialog.open(ManageRolesComponent, {
                disableClose: true,
                data: { data: data, juri: this.userRolePermissions?.jurisdiction }, height: '80vh', width: '80vw',
            })

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.ngOnInit();
                    this.commonService.roleSubjectChanged.next(true);
                }
            });
        }
        catch (error: any) {
            if (error.status && error.status == 401) {
                this.commonService.apiSecurityError();
            }
        }
    }


    async openSupportedJurisdictions() {

        let jurisdictionData: Jurisdiction[] = [];

        try {

            const dialogRef = this.dialog.open(ManageSupportedJurisdictionComponent, {
                 disableClose: true,
                 height: '80vh', width: '80vw',
            })

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.ngOnInit();
                }
            });
        }
        catch (error: any) {
            console.error(error);
        }
    }
}
